import PropTypes from "prop-types";
import _ from "lodash";

import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import React from "react";

/** Keeps customer details readable with a primary name and quieter contact information. */
const Customer = ({ customer, sx }) => {
  if (!customer) return null;
  return (
    <SoftBox
      sx={{ minWidth: 280, maxWidth: 320, overflowWrap: "anywhere", whiteSpace: "normal", ...sx }}
    >
      <SoftTypography
        component="div"
        variant="caption"
        fontWeight="medium"
        sx={{ lineHeight: 1.4 }}
      >
        {_.get(customer, "name", "N/A")}
      </SoftTypography>
      <SoftTypography
        component="div"
        variant="caption"
        color="secondary"
        sx={{ lineHeight: 1.4, fontSize: 12.5, mt: 0.375 }}
      >
        {_.get(customer, "email", "N/A")}
      </SoftTypography>
      <SoftTypography
        component="div"
        variant="caption"
        color="secondary"
        sx={{ lineHeight: 1.4, fontSize: 12.5 }}
      >
        Phone: {_.get(customer, "phone", "N/A")}
      </SoftTypography>
      <SoftTypography
        component="div"
        variant="caption"
        color="secondary"
        sx={{ lineHeight: 1.4, fontSize: 12.5 }}
      >
        IP: {_.get(customer, "ip", "N/A")}
      </SoftTypography>
    </SoftBox>
  );
};

Customer.defaultProps = {
  customer: {},
};

// Typechecking props of the Customer
Customer.propTypes = {
  customer: PropTypes.object,
  sx: PropTypes.object,
};
export default Customer;
